import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Grid } from '@mui/material'

import OrderAPI from '../../../../../api/orbitV1/OrderAPI'
import BreadcrumbsMUI from '../../../../../common/AbstractBreadcrumbs/BreadcrumbsMUI'
import PageLayout from '../../../../../common/Layout/Page/PageLayout'
import { ColorBoxContent } from '../../../../../common/ui/colorBox'
import SelectedOrderHeader from '../components/SelectedOrderHeader'

import OrderStateView from './components/OrderStateView'

function ViewIndividualOrderPage() {
  const { orderId } = useParams()

  /**
   * Fetch from backend and store into state.
   * @type {[import('../../../../../types/order.type').OrderModel | null, *]}
   */
  const [order, setOrder] = useState(null)

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const orderStatus = await OrderAPI.getOrderStatus(orderId)
        setOrder(orderStatus.data)
      } catch (error) {
        toast.error(error.response.message)
      }
    }

    fetchOrders()
  }, [orderId])

  /**
   * Fetch from backend and store into state.
   * @type {[import('../../../../../types/provision.type').ProvisioningStatus | null, *]}
   */
  const [provisionedItems, setProvisionedItems] = useState(null)

  useEffect(() => {
    async function getProvisionedItemsForOrder() {
      try {
        const provisionedItems = await OrderAPI.getProvisionedItemsForOrder(
          orderId
        )
        setProvisionedItems(provisionedItems.data)
      } catch (error) {
        toast.error('Failed to retrieve provisioned items')
      }
    }

    getProvisionedItemsForOrder()
  }, [orderId])

  if (!order) {
    return <div>Loading</div>
  }
  return (
    <PageLayout header='View Individual Order'>
      <Grid container direction='column' spacing={2}>
        <Grid item>
          <ColorBoxContent variant='white'>
            <BreadcrumbsMUI
              crumbs={[
                {
                  route: '/hq/manage-orders',
                  name: 'Manage Orders'
                },
                {
                  route: `/hq/manage-orders/${order.orderNo}`,
                  name: `Manage ${order.orderNo}`
                }
              ]}
            />
          </ColorBoxContent>
        </Grid>

        <Grid item>
          <ColorBoxContent>
            <SelectedOrderHeader order={order} />
          </ColorBoxContent>
          <OrderStateView order={order} provisionedItems={provisionedItems} />
        </Grid>
      </Grid>
    </PageLayout>
  )
}

export default ViewIndividualOrderPage
